/**
 * Formatação de data para a UI de chamados. Puro e testável — `widget.ts` não tem
 * cobertura, então tudo que tem regra sai de lá.
 *
 * Sem `Intl.RelativeTimeFormat` e sem dependência de locale do host: o widget roda na
 * página de terceiros, onde não controlamos nada, e "12/03/2026 14:30" é legível em
 * qualquer configuração. ISO inválido devolve "" (a UI omite a linha em vez de mostrar
 * "Invalid Date").
 */
export function dataCurta(iso: string | null | undefined): string {
  if (typeof iso !== "string" || iso === "") return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";

  const p2 = (n: number): string => String(n).padStart(2, "0");

  return `${p2(d.getDate())}/${p2(d.getMonth() + 1)}/${d.getFullYear()} ${p2(d.getHours())}:${p2(d.getMinutes())}`;
}

/**
 * O instante do jeito que cabe numa linha de meta (DEV-216): só a hora quando é de HOJE,
 * dia e hora quando não é.
 *
 * O balão de resposta nova dispara tanto pelo que chegou agora quanto pelo que chegou
 * enquanto a pessoa estava fora — e sem esta linha os dois casos ficam idênticos na tela,
 * com o segundo se passando por recém-chegado. `agora` entra por parâmetro pela mesma
 * razão que as funções de data do front: teste de data que lê o relógio quebra sozinho.
 */
export function horaCurta(iso: string | null | undefined, agora: Date): string {
  if (typeof iso !== "string" || iso === "") return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";

  const p2 = (n: number): string => String(n).padStart(2, "0");
  const hora = `${p2(d.getHours())}:${p2(d.getMinutes())}`;
  const mesmoDia =
    d.getFullYear() === agora.getFullYear() && d.getMonth() === agora.getMonth() && d.getDate() === agora.getDate();

  return mesmoDia ? hora : `${p2(d.getDate())}/${p2(d.getMonth() + 1)} ${hora}`;
}
